//create enum for weight units below
export enum WeightUnits {
    lb = 'lb', // Pounds
    kg = 'kg', // Kilograms
    g = 'g', // Grams
    oz = 'oz', // Ounces
    mg = 'mg', // Milligrams
    ton = 'ton', // Tons (US)
    tonne = 'tonne', // Metric Tons
}
export enum ProductDetailDataKeys {
    Name = 'name',
    Status = 'isActive',
    Description = 'description',
    DescriptionEditorRawContent = 'descriptionEditorRawContent',
    Category = 'category',
    HasVariants = 'hasVariants',
    Sku = 'sku',
    BarCode = 'barCode',
    Surcharge = 'surcharge',
    Discount = 'discount',
    Review = 'review',
    Return = 'return',
    ReturnDays = 'returnDays',
    Media = 'medias',
}

export enum ProductPricingPageDataKeys {
    PricingModel = 'pricingModel',
    AllowReOrder = 'allowReOrder',
    ReOrderIntervals = 'reOrderIntervals',
    ReOrderDiscountPercentage = 'discountPercentage',
    IsTrackInventory = 'isTrackInventory',
    AvailableInventory = 'available',
    IsSellOnOutOfStock = 'isSellOnOutOfStock',
    IsPromote = 'isPromote',
    IsLimitPurchaseQuantity = 'isLimitPurchaseQuantity',
    QuantityLimit = 'quantityLimit',
}

export enum UpsertProductActiveStep {
    Detail = 'Detail',
    Pricing = 'Pricing',
    Variants = 'Variants',
    Options = 'Options',
}

export enum ItemCategories {
    AnimalsAndPetSupplies = 'Detail',
    ApparelAndAccessories = 'Apparel And Accessoriess',
    ArtsAndEntertainment = 'Arts And Entertainments',
    BodyAndToddler = 'Body And Toddler',
    BusinessAndIndustrial = 'Business And Industrials',
    CamerasAndOptics = 'Cameras And Optics',
    Electronics = 'Electronics',
    FoodBeveragesAndTobacco = 'Food Beverages And Tobacco',
    Furniture = 'Furniture',
    Hardware = 'Hardware',
    HealthAndBeauty = 'Health And Beauty',
    HomeAndGarden = 'Home And Garden',
    LuggageAndBags = 'Luggage And Bags',
    Mature = 'Mature',
    Media = 'Media',
    OfficeSupplies = 'Office Supplies',
    ReligiousAndCareMonial = 'Religious And Care Monial',
    Software = 'Software',
    SportingAndGoods = 'Sporting And Goods',
    ToysAndGames = 'Toys And Games',
    VehiclesAndParts = 'Vehicles And Parts',
    GiftCards = 'Gift Cards',
}

export enum ItemOptionTypes {
    Item = 'Item',
    Category = 'Category',
    IssueCredits = 'IssueCredits',
}

export enum ItemTypes {
    Product = 'Product',
    Membership = 'Membership',
    Service = 'Service',
    Donation = 'Donation',
    Category = 'Category',
}

export enum AttributeTypes {
    Size = 'Size',
    Color = 'Color',
    Style = 'Style',
    Pattern = 'Pattern',
    Flavor = 'Flavor',
    Weight = 'Weight',
    Experience = 'Experience',
    Level = 'Level',
    Custom = 'Custom',
}

export enum AttributeValueTypes {
    Text = 'Text',
    Color = 'Color',
}
